import { css } from 'styled-components';

import { Cell } from '../styles';

const X5Terminal9Styled = css`
  display: flex;
  flex-direction: column;
  gap: 1px;

  ${Cell}:nth-child(1) {
    height: 20%;
  }

  ${Cell}:nth-child(2) {
    height: 7%;
  }

  ${Cell}:nth-child(3) {
    height: 12%;
  }

  ${Cell}:nth-child(4) {
    height: 12%;
  }

  ${Cell}:nth-child(5) {
    height: 7%;
  }

  ${Cell}:nth-child(6) {
    height: 7%;
  }

  ${Cell}:nth-child(7) {
    height: 9%;
  }

  ${Cell}:nth-child(8) {
    height: 9%;
  }

  ${Cell}:nth-child(9) {
    height: 17%;
  }
`;

export default X5Terminal9Styled;
